import { isApp, ENV_IOS, env } from '@bcz/fe-interface'
export const ORDER_SUC_CODE = 400
export const ALI_MOBILE_PAY = 101 //支付宝移动网站支付
export const ALI_CLIENT_PAY = 102 //支付宝客户端支付
export const ALI_PC_PAY = 103 //支付宝pc web扫码支付
export const ALI_NEW_H5_PAY = 111 // 新版本支付宝 h5支付
export const ALI_NEW_APP_PAY = 112 //新版本支付宝 app支付
export const ALI_NEW_WEB_PAY = 113 //新版本支付宝 web扫码支付

export const WX_GZH_PAY = 201 //微信公众号支付
export const WX_CLIENT_PAY = 202 // 微信客户端支付
export const WX_MINI_PAY = 203 //微信小程序支付
export const WX_H5_PAY = 204 //微信h5支付
export const WX_NATIVE_PAY = 205 //微信native支付（pc web扫码支付）
export const QQ_GZH_PAY = 301 //QQ 公众号支付
export const QQ_CLIENT_PAY = 302 //QQ 客户端支付
export const COIN_IOS_PAY = 401 //学习币IOS
export const COIN_ANDRIOD_PAY = 402 //学习币Android
export const COIN_BILL_PAY = 403 //学习币IOS直接通过苹果收据支付

export const FAMILY_PAY_CODE = -1 //亲友代付

/**
 * 收款账号
 */
export const PRODUCT_ID = 1

/**
 * 客户端返回的
 */
export const PAY_TYPE_MAP = {
  [ALI_CLIENT_PAY]: 'alipay_mob_client',
  [WX_CLIENT_PAY]: 'weixin_app',
  [QQ_CLIENT_PAY]: 'qq_app',
  [COIN_IOS_PAY]: 'coin_v3',
}
export const ALI_PAY = 'alipay_mob_client'
export const WX_PAY = 'weixin_app'
export const QQ_PAY = 'qq_app'
export const COIN_PAY = 'coin_v3'
export const FAMILY_PAY = 'help_pay'
export const APP_PAYS = {
  [WX_PAY]: {
    txt: '微信',
    img: require('../assets/img/pay-icon1.png'),
    code: WX_CLIENT_PAY,
    type: WX_PAY,
  },
  [ALI_PAY]: {
    txt: '支付宝',
    img: require('../assets/img/pay-icon2.png'),
    code: ALI_CLIENT_PAY,
    type: ALI_PAY,
  },
  [QQ_PAY]: {
    txt: 'QQ',
    img: require('../assets/img/pay-icon3.png'),
    code: QQ_CLIENT_PAY,
    type: QQ_PAY,
  },

  [COIN_PAY]: {
    txt: '学习币',
    img: require('../assets/img/pay-icon4.png'),
    code: COIN_IOS_PAY,
    type: COIN_PAY,
  },
  [FAMILY_PAY]: {
    txt: '亲友代付',
    img: require('../assets/img/pay-icon5.png'),
    code: FAMILY_PAY_CODE,
    type: FAMILY_PAY,
  },
}

//移动网站
const WX_PAYS = [
  {
    txt: '微信',
    img: require('../assets/img/pay-icon1.png'),
    code: WX_GZH_PAY,
  },
  {
    txt: '支付宝',
    img: require('../assets/img/pay-icon2.png'),
    code: ALI_MOBILE_PAY,
  },

  {
    txt: '亲友代付',
    img: require('../assets/img/pay-icon5.png'),
    code: FAMILY_PAY_CODE,
  },
]

const findItemByType = (methods, type) => {
  for (let i = 0, len = methods.length; i < len; i++) {
    if (methods[i].type === type) {
      return methods[i]
    }
  }
}

/**
 *
 * @param {Array<{  txt:string,img: string,code: number,type: string,}>} methods
 */
export function sortPayMethod(methods) {
  if (!Array.isArray(methods)) []
  const result = []
  const wx = findItemByType(methods, WX_PAY)
  if (wx) {
    result.push({ ...wx })
  }
  const al = findItemByType(methods, ALI_PAY)
  if (al) {
    result.push({ ...al })
  }
  const res = [
    ...result,
    ...methods.filter(item => {
      return item.type !== ALI_PAY && item.type !== WX_PAY
    }),
  ]
  return res
}

/**
 * 得到支持的支付方式
 * @param {boolean} [isVirtual] 是否是虚拟支付订单
 * @param {{stepPay?: boolean}} [opt]
 */
export function getSupportMayMethod(isVirtual, opt = {}) {
  if (!isApp) {
    if (opt.stepPay) {
      return WX_PAYS.filter(item => {
        return item.code !== FAMILY_PAY_CODE
      })
    }
    return WX_PAYS
  }

  const cookie = document.cookie
  const patt = /Pay-Support-H5=(.*?);/
  const group = cookie.match(patt)
  const str = (group && group[1]) || ''
  // 如果 str 为空的时候，会导致 arr 有一个空元素，我们需要去掉
  const arr = str
    .replace(/"/g, '')
    .split(':')
    .filter(x => x)
  // if (!filter) return arr
  // const arr = ['alipay_mob_client', 'weixin_app', 'qq_app', 'huawei_app']
  try {
    //在app内，如果订单含虚拟商品,并且是ios，直接返回学习币支付
    if (isVirtual && env === ENV_IOS) {
      return [{ ...APP_PAYS[COIN_PAY] }]
    }
    //暂时没有虚拟商品，所以先不支持虚拟币支付(结算页不支持，订单页支持)
    const res = arr.filter(item => {
      return APP_PAYS[item] && item !== PAY_TYPE_MAP[COIN_IOS_PAY]
    })

    if (!opt.stepPay) {
      res.push(FAMILY_PAY)
    }
    const m = res.map(item => {
      return {
        ...APP_PAYS[item],
      }
    })
    return sortPayMethod(m)
  } catch (error) {
    if (!opt.stepPay) return [{ ...APP_PAYS[WX_PAY] }, { ...APP_PAYS[FAMILY_PAY] }]
    return [{ ...APP_PAYS[WX_PAY] }]
  }
}
